<template>
  <div id="hotel">
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive"></router-view>
  </div>
</template>

<script>
export default {
  name: 'hotel'
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/portal/service/hotel/Hotel.vue